<div class="max-w-4xl mx-auto min-h-screen">
    <p-toast></p-toast>
    
    <!-- Loading State -->
    <div *ngIf="isLoading" class="flex items-center justify-center min-h-screen">
        <div class="text-center">
            <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto mb-4"></div>
            <p class="text-gray-600" i18n>Loading customer details...</p>
        </div>
    </div>

    <!-- Header Section -->
    <div class="text-start mb-8 ml-2 lg:ml-0" *ngIf="!isLoading">
      <h2 class="font-bold text-2xl mb-1" i18n>{{ isEditMode ? 'Edit Customer' : 'Add New Customer' }}</h2>
      <p class="text-[#6B7280] text-sm m-0" i18n>{{ isEditMode ? 'Update the customer information below' : 'Fill in the information below' }}</p>
    </div>
  
    <!-- Progress Section -->
    <!-- <div class="mb-8">
      <div class="flex items-center justify-between mb-4">
        <span class="text-sm font-medium text-gray-500">Step {{ currentStep }} of {{ totalSteps }}</span>
        <span class="text-sm font-semibold text-gray-800">
          {{ currentStep === 1 ? 'Secure Your Account' : 'Personal Information' }}
        </span>
      </div>
      <p-progressBar [value]="getProgressPercentage()" [showValue]="false" styleClass="h-11"></p-progressBar>
    </div> -->
  
   
  
  
    <!-- Step 2: Personal Information -->
    <div class="space-y-6" *ngIf="!isLoading">
      <form [formGroup]="customerForm" class="space-y-8">
          <p-card styleClass="p-4">
            <!-- Personal Information Section -->
            <div class="">
              <div class="flex items-center gap-3 mb-6">
                <i class="pi pi-user text-xl text-gray-600"></i>
                <h3 i18n>Customer Information</h3>
              </div>
  
              <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div class="flex flex-col gap-2">
                  <label for="businessName" class="font-medium text-gray-800 mb-1" i18n>
                    Business Name <span class="text-red-500">*</span>
                  </label>
                  <input 
                    id="businessName"
                    type="text" 
                    pInputText 
                    formControlName="businessName"
                    placeholder="Enter business name" i18n-placeholder
                    class="w-full rounded-lg border border-gray-300 text-base transition-all duration-200 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100 invalid:border-red-500 invalid:focus:ring-red-100"
                   
                  />
                  <small class="text-red-500 text-sm mt-1" *ngIf="getFieldError('businessName')">
                    {{ getFieldError('businessName') }}
                  </small>
                </div>

                <!-- businessId is auto-generated on the server -->
  
                <div class="flex flex-col gap-2">
                  <label for="zipCode" class="font-medium text-gray-800 mb-1" i18n>
                    ZIP Code <span class="text-red-500">*</span>
                  </label>
                  <input 
                    id="zipCode"
                    type="text" 
                    pInputText 
                    formControlName="zipCode"
                    i18n-placeholder
                    placeholder="Enter ZIP code" i18n-placeholder
                    class="w-full rounded-lg border border-gray-300 text-base transition-all duration-200 focus:border-indigo-400 focus:ring-indigo-100 invalid:border-red-500 invalid:focus:ring-red-100"
                   
                  />
                  <small class="text-red-500 text-sm mt-1" *ngIf="getFieldError('zipCode')">
                    {{ getFieldError('zipCode') }}
                  </small>
                </div>
              </div>
  
              <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                <div class="flex flex-col gap-2">
                    <label for="industry" class="font-medium text-gray-800 mb-1" i18n>
                        Industry  <span class="text-red-500">*</span>
                    </label>
                    <p-select 
                      id="industry"
                      formControlName="industry"
                      [options]="industryOptions"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Select industry" i18n-placeholder
                      class="w-full rounded-lg border border-gray-300 text-base transition-all duration-200 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100 invalid:border-red-500 invalid:focus:ring-red-100"
                     
                    >
                    </p-select>
                   
                  </div>

                  <div class="flex flex-col gap-2">
                    <label for="numberOfEmployees" class="font-medium text-gray-800 mb-1" i18n>
                        Number of Employees  <span class="text-red-500">*</span>
                    </label>
                    <p-select 
                      id="numberOfEmployees"
                      formControlName="numberOfEmployees"
                     
                      [options]="numberOfEmployeesOptions"
                      optionValue="value"
                      placeholder="Select Range" i18n-placeholder 
                      class="w-full rounded-lg border border-gray-300 text-base transition-all duration-200 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100 invalid:border-red-500 invalid:focus:ring-red-100"
                     
                    >
                    </p-select>
                   
                  </div>

  
                
              </div>

            </div>
          
                        <!-- Decision Maker Information Section -->
            <div class="mt-10">
              <div class="flex flex-wrap items-center justify-between mb-6">
                <div class="flex items-center gap-3">
                  <i class="pi pi-home text-xl text-gray-600"></i>
                  <h3 class="" i18n>Decision Maker Information</h3>
                </div>
                <p-button appGlobalLoadingDisable 
                  type="button" 
                  icon="pi pi-plus" 
                  label="Add Decision Maker" i18n-label
                  size="small"
                  styleClass="p-button-outlined "
                  class="mt-2 md:mt-0"
                  (onClick)="addDecisionMaker()"
                ></p-button>
              </div>

              <!-- Decision Makers Form Array -->
              <div formArrayName="decisionMakers" class="space-y-6">
                <div *ngFor="let decisionMaker of decisionMakers.controls; let i = index" [formGroupName]="i" class="border border-gray-200 rounded-lg p-6 bg-gray-50">
                  <div class="flex items-center justify-between mb-4">
                    <h4 class="text-md font-medium text-gray-800" i18n>Decision Maker {{ i + 1 }}</h4>
                    <p-button 
                      *ngIf="decisionMakers.length > 1"
                      type="button" 
                      icon="pi pi-trash" 
                      severity="danger" 
                      size="small"
                      styleClass="p-button-text"
                      (onClick)="removeDecisionMaker(i)"
                    ></p-button>
                  </div>

                  <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div class="flex flex-col gap-2">
                        <label [for]="'salutation' + i" class="font-medium text-gray-800 mb-1" i18n>
                            Salutation  <span class="text-red-500">*</span>
                        </label>
                        <p-select 
                          [id]="'salutation' + i"
                          formControlName="salutation"
                          [options]="salutationOptions"
                          optionValue="value"
                          placeholder="Select" i18n-placeholder
                          class="w-full rounded-lg border border-gray-300 text-base transition-all duration-200 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100 invalid:border-red-500 invalid:focus:ring-red-100"
                        >
                        </p-select>
                        <small class="text-red-500 text-sm mt-1" *ngIf="getDecisionMakerFieldError(i, 'salutation')">
                          {{ getDecisionMakerFieldError(i, 'salutation') }}
                        </small>
                      </div>
                    <div class="flex flex-col gap-2">
                      <label [for]="'firstName' + i" class="font-medium text-gray-800 mb-1" i18n>
                        First Name <span class="text-red-500">*</span>
                      </label>
                      <input 
                        [id]="'firstName' + i"
                        type="text" 
                        pInputText 
                        formControlName="firstName"
                        placeholder="First name" i18n-placeholder
                        class="w-full rounded-lg border border-gray-300 text-base transition-all duration-200 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100 invalid:border-red-500 invalid:focus:ring-red-100"
                      />
                      <small class="text-red-500 text-sm mt-1" *ngIf="getDecisionMakerFieldError(i, 'firstName')">
                        {{ getDecisionMakerFieldError(i, 'firstName') }}
                      </small>
                    </div>

                    <div class="flex flex-col gap-2">
                      <label [for]="'lastName' + i" class="font-medium text-gray-800 mb-1" i18n>
                        Last Name <span class="text-red-500">*</span>
                      </label>
                      <input 
                        [id]="'lastName' + i"
                        type="text" 
                        pInputText 
                        formControlName="lastName"
                        placeholder="Last name" i18n-placeholder
                        class="w-full rounded-lg border border-gray-300 text-base transition-all duration-200 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100 invalid:border-red-500 invalid:focus:ring-red-100"
                      />
                      <small class="text-red-500 text-sm mt-1" *ngIf="getDecisionMakerFieldError(i, 'lastName')">
                        {{ getDecisionMakerFieldError(i, 'lastName') }}
                      </small>
                    </div>
                  </div>

                  <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                    <div class="flex flex-col gap-2">
                      <label [for]="'mobileNumber' + i" class="font-medium text-gray-800 mb-1" i18n>
                        Mobile Number <span class="text-red-500">*</span>
                      </label>
                      <input 
                        [id]="'mobileNumber' + i"
                        type="text" 
                        pInputText 
                        formControlName="mobileNumber"
                        placeholder="Enter phone number" i18n-placeholder
                        class="w-full rounded-lg border border-gray-300 text-base transition-all duration-200 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100 invalid:border-red-500 invalid:focus:ring-red-100"
                      />
                      <small class="text-red-500 text-sm mt-1" *ngIf="getDecisionMakerFieldError(i, 'mobileNumber')">
                        {{ getDecisionMakerFieldError(i, 'mobileNumber') }}
                      </small>
                    </div>

                    <div class="flex flex-col gap-2">
                      <label [for]="'email' + i" class="font-medium text-gray-800 mb-1" i18n  >
                        Email Address <span class="text-red-500">*</span>
                      </label>
                      <input 
                        [id]="'email' + i"
                        type="email" 
                        pInputText 
                        formControlName="email"
                        placeholder="Email address" i18n-placeholder
                        class="w-full rounded-lg border border-gray-300 text-base transition-all duration-200 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100 invalid:border-red-500 invalid:focus:ring-red-100"
                      />
                      <small class="text-red-500 text-sm mt-1" *ngIf="getDecisionMakerFieldError(i, 'email')">
                        {{ getDecisionMakerFieldError(i, 'email') }}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Interest Level and Promotional Gifts Section -->
            <div class="mt-10">
              <div class="flex items-center gap-3 mb-6">
                <i class="pi pi-chart-line text-xl text-gray-600"></i>
                <h3 class="" i18n>Additional Information</h3>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div class="flex flex-col gap-2">
                    <label for="interestLevel" class="font-medium text-gray-800 mb-1" i18n>
                        Interest Level  <span class="text-red-500">*</span>
                    </label>
                    <p-select 
                      id="interestLevel"
                      formControlName="interestLevel"
                      [options]="interestLevelOptions"
                      optionValue="value"
                      placeholder="Select interest level" i18n-placeholder
                      class="w-full rounded-lg border border-gray-300 text-base transition-all duration-200 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100 invalid:border-red-500 invalid:focus:ring-red-100"
                    >
                    </p-select>
                    <small class="text-red-500 text-sm mt-1" *ngIf="getFieldError('interestLevel')">
                      {{ getFieldError('interestLevel') }}
                    </small>
                  </div>
                  <div class="flex flex-col gap-2">
                    <label for="customerOrigin" class="font-medium text-gray-800 mb-1" i18n>
                      Customer Origin <span class="text-red-500">*</span>
                    </label>
                    <p-select 
                      id="customerOrigin"
                      formControlName="customerOrigin"
                      [options]="customerOriginOptions"
                      optionValue="value"
                      placeholder="Select customer origin" i18n-placeholder
                      class="w-full rounded-lg border border-gray-300 text-base transition-all duration-200 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100 invalid:border-red-500 invalid:focus:ring-red-100"
                    >
                    </p-select>
                    <small class="text-red-500 text-sm mt-1" *ngIf="getFieldError('customerOrigin')">
                      {{ getFieldError('customerOrigin') }}
                    </small>
                  </div>
              </div>

              <div class="grid grid-cols-1 gap-6 mt-6">
                <div class="flex flex-col gap-2">
                    <label for="acceptedPromotionalGifts" class="font-medium text-gray-800 mb-1" i18n>
                        Has accepted promotional gifts <span class="text-red-500">*</span>
                    </label>
                    <div class="card flex justify-start gap-4">
                        <div class="flex items-center">
                            <p-radiobutton inputId="yes" formControlName="acceptedPromotionalGifts" value="yes" />
                            <label for="yes" class="ml-2" i18n> Yes </label>
                        </div>
                        <div class="flex items-center">
                            <p-radiobutton inputId="no" formControlName="acceptedPromotionalGifts" value="no" />
                            <label for="no" class="ml-2" i18n> No </label>
                        </div>
                    </div>
                    
                  
                  </div>
              </div>

              <div class="grid grid-cols-1 gap-6 mt-6 pb-5">
                <div class="flex flex-col gap-2">
                  <label for="notes" class="font-medium text-gray-800 mb-1" i18n>
                    Notes
                  </label>
                  <p-editor 
                    id="notes"
                    formControlName="notes"
                    styleClass="notes-editor"
                  ></p-editor>
                </div>
              </div>
            </div>

            <!-- Documents Upload Section -->
          <div class="mt-10">
            <div class="flex items-center gap-3 mb-6">
              <!-- <i class="pi pi-cloud-upload text-xl text-gray-600"></i> -->
              <h3 class="" i18n>Upload Document </h3>
            </div>

            <div class="grid grid-cols-1 gap-6">
              <div class="flex flex-col gap-2">
                <!-- File Upload Progress -->
                <div *ngIf="isFileUploading" class="mb-4">
                  <p-progressBar mode="indeterminate" styleClass="h-2"></p-progressBar>
                  <small class="text-gray-500 text-sm mt-2 block" i18n >Uploading file...</small>
                </div>

                <!-- Uploaded File Display -->
                <div *ngIf="uploadedFileUrl && !isFileUploading" class="mb-4 p-4 bg-green-50 border border-green-200 rounded-lg">
                  <div class="flex items-center justify-between">
                    <div class="flex items-center gap-3">
                      <i class="pi pi-file text-green-600"></i>
                      <span class="text-green-800 font-medium" i18n>File uploaded successfully</span>
                    </div>
                    <p-button appGlobalLoadingDisable 
                      type="button" 
                      icon="pi pi-times" 
                      severity="secondary" 
                      size="small"
                      (onClick)="removeUploadedFile()"
                      styleClass="p-button-text"
                    ></p-button>
                  </div>
                  
                  <!-- Show thumbnail only for image files -->
                  <div *ngIf="uploadedFile && isImageFile(uploadedFile)" class="mt-4">
                    <h5 class="text-sm font-medium text-gray-700 mb-2" i18n>Preview</h5>
                    <div class="flex justify-center">
                      <img [src]="uploadedFileUrl" alt="File preview" i18n-alt class="max-w-full h-auto max-h-48 object-contain border rounded-lg shadow-sm" />
                    </div>
                  </div>
                </div>

                <!-- Hidden documents field -->
                <input type="hidden" formControlName="documents" />

                <!-- Main File Upload with Drag & Drop -->
                <div 
                  class="mb-4 p-4 border-2 border-dashed rounded-lg text-center drag-drop-area"
                  [class]="dragOver ? 'border-blue-500 bg-blue-50 drag-over' : 'border-gray-300'"
                  [class.loading]="isFileUploading"
                  (dragover)="onDragOver($event)"
                  (dragleave)="onDragLeave($event)"
                  (drop)="onDrop($event)">
                  
                  <input 
                    type="file" 
                    accept="application/pdf,image/png,image/jpeg,image/jpg"
                    (change)="onFileUpload($event)"
                    class="hidden"
                    [disabled]="isFileUploading"
                    id="file-input-idCard" />
                  
                  <div class="flex flex-col items-center justify-center py-4">
                    <svg class="mb-2" width="38" height="27" viewBox="0 0 38 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.6875 26.875C4.0293 26.875 0.25 23.0957 0.25 18.4375C0.25 14.7578 2.60547 11.6289 5.88672 10.4746C5.88086 10.3164 5.875 10.1582 5.875 10C5.875 4.82031 10.0703 0.625 15.25 0.625C18.7246 0.625 21.7539 2.51172 23.377 5.32422C24.2676 4.72656 25.3457 4.375 26.5 4.375C29.6055 4.375 32.125 6.89453 32.125 10C32.125 10.7148 31.9902 11.3945 31.75 12.0273C35.1719 12.7188 37.75 15.748 37.75 19.375C37.75 23.5176 34.3926 26.875 30.25 26.875H8.6875ZM13.3164 14.1602C12.7656 14.7109 12.7656 15.6016 13.3164 16.1465C13.8672 16.6914 14.7578 16.6973 15.3027 16.1465L17.5879 13.8613V21.7188C17.5879 22.498 18.2148 23.125 18.9941 23.125C19.7734 23.125 20.4004 22.498 20.4004 21.7188V13.8613L22.6855 16.1465C23.2363 16.6973 24.127 16.6973 24.6719 16.1465C25.2168 15.5957 25.2227 14.7051 24.6719 14.1602L19.9844 9.47266C19.4336 8.92188 18.543 8.92188 17.998 9.47266L13.3105 14.1602H13.3164Z" fill="#9CA3AF"/>
                    </svg>
                    <label 
                      for="file-input-idCard" 
                      class="cursor-pointer text-blue-600 hover:text-blue-800 font-medium"
                      [class.opacity-50]="isFileUploading"
                      [class.cursor-not-allowed]="isFileUploading">
                      <span *ngIf="isFileUploading" i18n>Uploading...</span>
                      <span *ngIf="!isFileUploading" i18n>Click to upload or drag and drop</span>
                    </label>
                    <p class="text-sm text-gray-500 mt-2" i18n>
                      PDF, PNG, JPG (MAX. 10MB)
                    </p>
                  </div>
                </div>
                <!-- <small class="text-red-500 text-sm mt-1" *ngIf="getFieldError(personalInfoForm, 'idCard')">
                  {{ getFieldError(personalInfoForm, 'idCard') }}
                </small> -->
              </div>
            </div>
          </div>
          </p-card>
            <!-- Submit Button -->
            <div class="flex justify-end gap-3 pt-6">
              <p-button 
                *ngIf="isDrawerMode"
                type="button" 
                label="Cancel" i18n-label
                [disabled]="isSubmitting"
                severity="secondary"
                (onClick)="cancelled.emit()"
              >
              </p-button>
              <p-button 
                type="button" 
                [label]="isEditMode ? 'Update Customer' : 'Add Customer'" i18n-label
                [loading]="isSubmitting"
                [disabled]="isSubmitting || isLoading"
                styleClass="p-button-primary"
                (onClick)="onSubmit()"
              >
              </p-button>
            </div>
          
  
    </form>
    </div>
  </div>
  